<template>
    <b-container v-if="mixinCheckPermission('RECEIPT_EDIT') && !!receipt.uuid">
        <b-row>
            <b-col cols="auto">
                <b-form-radio-group
                    v-model="actionSelected"
                    name="receipt-actions"
                    class="d-flex flex-column">
                    <div>
                        <b-form-radio value="CHARGE_WITHOUT_CALL">
                            Cobrar sin llamar
                        </b-form-radio>
                        <template v-if="actionSelected==='CHARGE_WITHOUT_CALL'">
                            <i
                                class="fa fa-calendar btn-calendar"
                                @click="showChargeDateModal()"></i>
                        </template>
                    </div>

                    <div>
                        <b-form-radio value="CHARGE_AFTER_CALL">
                            Cobrar tras llamada
                        </b-form-radio>
                        <template v-if="actionSelected==='CHARGE_AFTER_CALL'">
                            <i
                                class="fa fa-calendar btn-calendar"
                                @click="showChargeDateModal()"></i>
                        </template>
                    </div>

                    <b-form-radio value="PAID_WITH_BANK">
                        Pagado vía transferencia
                    </b-form-radio>

                    <b-form-radio value="PAID_WITH_CARD">
                        Pagado vía tarjeta
                    </b-form-radio>

                    <b-form-radio value="PENDING">
                        Pendiente de cobro por otra vía
                    </b-form-radio>

                    <b-form-radio value="CANCEL">
                        Anular / Condonar
                    </b-form-radio>

                    <div v-if="mixinCheckPermission('EDIT_MEMBER_STATUS') && receipt.member.active">
                        <b-form-radio value="UNSUBSCRIBE">
                            Dar de baja al socio
                        </b-form-radio>
                        <template v-if="actionSelected==='UNSUBSCRIBE'">
                            <i
                                class="fa fa-gears btn-calendar"
                                @click="showUnsubscribeMemberModal()"></i>
                        </template>
                    </div>
                </b-form-radio-group>
            </b-col>

            <b-col col class="d-flex flex-row-reverse align-content-end align-items-end">
                <div>
                    <button
                        :disabled="!actionSelected"
                        class="btn btn-primary btn-sm"
                        @click="applyAction">
                        Aplicar
                    </button>
                </div>
            </b-col>
        </b-row>

        <b-modal
            ref="chargeDateModal"
            hide-footer
            size="sm"
            title="Cobrar Recibo">
            <b-container class="py-2">
                <b-row>
                    <b-col>
                        <b-form-group
                            label="<strong>Fecha de cargo</strong>">
                            <v-date-picker
                                id="chargeDate"
                                v-model="chargeDate"
                                class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col col class="d-flex flex-row-reverse">
                        <div>
                            <button
                                class="btn btn-secondary btn-md"
                                @click="closeChargeDateModal()">
                                Aceptar
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <b-modal
            ref="unsubscribeMemberModal"
            hide-footer
            size="md"
            title="Baja de Socio">
            <b-container class="py-2">
                <b-row>
                    <b-col>
                        <b-form-group
                            label="<strong>Motivo de Baja *</strong>"
                            label-for="unsubscribe-reason">
                            <client-unsubscribe-reason-selector
                                id="unsubscribe-reason"
                                v-model="unsubscribeReason"></client-unsubscribe-reason-selector>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group
                            class="text-left">
                            <b-form-checkbox
                                v-model="deferredUnsubscribe">
                                Baja en Diferido
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-if="deferredUnsubscribe">
                    <b-col>
                        <b-form-group
                            label="<strong>Fecha de baja</strong>">
                            <v-date-picker
                                :min-date="getTomorrowDate()"
                                v-model="unsubscribeDate"
                                class="date-picker-w-100 date-picker-custom-border">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col col class="d-flex flex-row-reverse">
                        <div>
                            <button
                                class="btn btn-secondary btn-md"
                                @click="closeUnsubscribeMemberModal()">
                                Aceptar
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </b-container>

    <b-container v-else>
        <b-row>
            <b-col cols="auto">
                No tienes permisos para aplicar tratamientos
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {
        chargeReceiptByBank,
        payReceipt,
        receiptToPendingStatus,
        cancelReceipt
    } from '@/api/receipt-api';
    import {deactivateMember} from "@/api/member-api";
    import clientUnsubscribeReasonSelector
        from '@/components/clients/unsubscribe-reasons/ClientUnsubscribeReasonSelector';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: "ReceiptActions",
        components: {
            'v-date-picker': DatePicker,
            clientUnsubscribeReasonSelector
        },
        props: {
            value: Object
        },
        data: function () {
            return {
                receipt: this.value,
                actionSelected: null,
                chargeDate: null,
                unsubscribeReason: null,
                unsubscribeDate: null,
                deferredUnsubscribe: false
            }
        },
        computed: {
            validUnsubscribeMemberFields() {
                return (
                    !!this.unsubscribeReason
                    && !!this.unsubscribeReason.uuid
                    && (!this.deferredUnsubscribe || (this.deferredUnsubscribe && !!this.unsubscribeDate))
                )
            }
        },
        methods: {
            notifyChange(receipt) {
                this.$emit('input', receipt);
            },
            notifyReceiptRefreshRequired() {
                this.$emit('receipt-refresh-required');
            },
            showChargeDateModal() {
                this.$refs.chargeDateModal.show();
            },
            closeChargeDateModal() {
                this.$refs.chargeDateModal.hide();
            },
            showUnsubscribeMemberModal() {
                this.$refs.unsubscribeMemberModal.show();
            },
            closeUnsubscribeMemberModal() {
                this.$refs.unsubscribeMemberModal.hide();
            },
            getTomorrowDate() {
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                return tomorrow;
            },
            applyAction() {
                swal({
                    title: '¿Desea aplicar el tratamiento seleccionado?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        if (this.actionSelected === 'CHARGE_WITHOUT_CALL') {
                            this.chargeReceiptByBank(this.chargeDate, false);
                        } else if (this.actionSelected === 'CHARGE_AFTER_CALL') {
                            this.chargeReceiptByBank(this.chargeDate, true);
                        } else if (this.actionSelected === 'PAID_WITH_BANK') {
                            this.payReceipt('TRANSFER');
                        } else if (this.actionSelected === 'PAID_WITH_CARD') {
                            this.payReceipt('CARD');
                        } else if (this.actionSelected === 'PENDING') {
                            this.receiptToPendingStatus();
                        } else if (this.actionSelected === 'CANCEL') {
                            this.cancelReceipt();
                        } else if (this.actionSelected === 'UNSUBSCRIBE') {
                            if (!this.validUnsubscribeMemberFields) {
                                this.$_notificationMixin_error('Faltan campos obligatorios', 'Revise el formulario');
                            } else {
                                this.deactivateMember(this.unsubscribeReason.uuid, (this.deferredUnsubscribe ? this.unsubscribeDate : null));
                            }
                        }
                        this.actionSelected = null;
                    }
                });
            },
            async chargeReceiptByBank(chargeDate, memberCalled) {
                this.$_loadingMixin_showLoading();
                await chargeReceiptByBank(this.receipt.uuid, chargeDate, memberCalled)
                    .then((receipt) => {
                        this.receipt = receipt;
                        this.notifyChange(receipt);
                        this.$_notificationMixin_success('Operación completada', 'Recibo tratado con éxito');
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async payReceipt(chargedBy) {
                this.$_loadingMixin_showLoading();
                await payReceipt(this.receipt.uuid, chargedBy)
                    .then((receipt) => {
                        this.receipt = receipt;
                        this.notifyChange(receipt);
                        this.$_notificationMixin_success('Operación completada', 'Recibo tratado con éxito');
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async receiptToPendingStatus() {
                this.$_loadingMixin_showLoading();
                await receiptToPendingStatus(this.receipt.uuid)
                    .then((receipt) => {
                        this.receipt = receipt;
                        this.notifyChange(receipt);
                        this.$_notificationMixin_success('Operación completada', 'Recibo tratado con éxito');
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async cancelReceipt() {
                this.$_loadingMixin_showLoading();
                await cancelReceipt(this.receipt.uuid)
                    .then((receipt) => {
                        this.receipt = receipt;
                        this.notifyChange(receipt);
                        this.$_notificationMixin_success('Operación completada', 'Recibo tratado con éxito');
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async deactivateMember(unsubscribeReasonId, unsubscribeDate) {
                this.$_loadingMixin_showLoading();
                await deactivateMember(
                    this.receipt.member.uuid,
                    unsubscribeReasonId,
                    (!!unsubscribeDate ? unsubscribeDate : null)
                )
                    .then((member) => {
                        this.notifyReceiptRefreshRequired();
                        this.$_notificationMixin_success('Operación completada', 'El socio ha sido dado de baja');
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación no completada', 'No se ha podido dar de baja al socio');
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        watch: {
            value: function () {
                this.receipt = this.value;
            },
            actionSelected: function () {
                if (this.actionSelected === 'CHARGE_WITHOUT_CALL' || this.actionSelected === 'CHARGE_AFTER_CALL') {
                    this.showChargeDateModal();
                } else if (this.actionSelected === 'UNSUBSCRIBE') {
                    this.showUnsubscribeMemberModal();
                }
            }
        }
    }
</script>

<style scoped>
    .btn-calendar {
        cursor: pointer !important;
    }
</style>